import { Injectable , Renderer2, RendererFactory2} from '@angular/core'
import { TranslocoService } from '@jsverse/transloco'
import { Subscription, take } from 'rxjs'

@Injectable({
   providedIn: 'root'
})
export class LanguageService {
   availableLanguages: string[]
   language = 'en'
   locSubscription: Subscription | null = null
   renderer2: Renderer2

   constructor(rendererFactory: RendererFactory2, private translocoService: TranslocoService) {
      this.availableLanguages = this.translocoService.getAvailableLangs().map((lang) => lang.toString())
      this.renderer2 = rendererFactory.createRenderer(null, null)
   }

   changeLanguage(lang: string) {
      this.language = lang
      this.locSubscription?.unsubscribe()
      this.locSubscription =  this.translocoService
         .load(lang)
         .pipe(take(1))
         .subscribe(() => {
            if (lang == 'he' || lang == 'ar' || lang == 'fa') {
               this.renderer2.setAttribute(document.getElementsByTagName('html')[0], 'dir', 'rtl')
            }
            else {
               this.renderer2.setAttribute(document.getElementsByTagName('html')[0], 'dir', 'ltr')
            }
            this.translocoService.setActiveLang(lang)
         })
   }
}
